
<div class="container confirm">
    <div class="close row">
        <button (click)="closeDialog()" style="background: #fff;
    border: none;float: right;">
        <img src="./assets/images/close cross.svg">
    </button>
    </div>
    <div class="row title">
        Resend welcome letter?
    </div>
    <div class="buttonGrp">
        <button class="whiteButton" (click)="closeDialog()">Cancel</button>
        <button class="blueButton" (click)="resendLetter()">OK</button>
    </div>
</div>
